<template>
<div id="OccupyOrderDetail" v-if='OccupyOrderDetailShow'>
	<a-spin :spinning="loading" v-if="loading" class='loading-fullscreen'></a-spin>
	<div class="panel-container" v-if="type === TYPE.GATE">
        <div class="panel-title">
            <div class="title-area">占用订单状态</div>
            <div class="btn-area">
				<a-button v-if="needClearing && $auth('ADMIN')" type="primary" ghost @click="hanldeManualClearing">手动结算</a-button>
				<a-button v-if="flag.can_refund && refundBtnAble" type="danger" ghost @click="handleOrderRefundShow">订单退款</a-button>
			</div>
        </div>
        <div class="panel-content">
			<OccupyOrderStatus :status="detail.status" :detail="detail" :type='type' />
        </div>
    </div>
    <div class="panel-container"> <!-- 订单详情 -->
        <div class="panel-title">
            <!-- 充电柜 -->
            <template v-if="type === TYPE.TANK">
                <div class="title-area">占用订单详情</div>
                <div class="btn-area">
                    <a-button v-if="needClearing && $auth('ADMIN')" type="primary" ghost @click="hanldeManualClearing">手动结算</a-button>
                    <a-button v-if="flag.can_refund && refundBtnAble" type="danger" ghost @click="handleOrderRefundShow">订单退款</a-button>
                </div>
            </template>
            <!-- 汽车充占位 -->
            <template v-if="type === TYPE.CHARGE">
                <div class="title">
                    <template v-if="detail.pursue_order_status === PURSUE_STATUS.WAIT_PAY">已结束，待补款</template>
                    <template v-else>{{ $Filter.occupyOrderStatusFilter(detail.status) }}</template>
                </div>
                <div class="btn-area">
                    <a-tag class="status-tag" v-if="detail.refund_status !== 0">
                        {{ $Filter.orderRefundStatusFilter(detail.refund_status) }}
                    </a-tag>

                    <a-button v-if="needClearing && $auth('ADMIN')" type="primary" ghost @click="hanldeManualClearing">手动结算</a-button>
                    <a-button v-if="flag.can_refund && refundBtnAble && $auth('car-occupy.update')" type="danger" ghost @click="handleOrderRefundShow">订单退款</a-button>
                </div>
            </template>
        </div>
        <a-row class="panel-content" type='flex'>
            <!-- 用户信息 -->
            <a-col :xs='24' :sm="24" :md="12" :xl="6" class="panel-block-content">
                <div class="panel-block">
                    <div class="block-title"><span>用户信息</span></div>
                    <div class="block-detail">
                        <div class="detail-item">
                            <span class="key">用户头像:</span>
                            <span class="value">
                                <a-avatar :size='30' :src="(userDetail ? userDetail.avatar : '') | avatarFormat" icon="user"/>
                            </span>
                        </div>
                        <div class="detail-item">
                            <span class="key">用户昵称:</span>
                            <span class="value">
                                <span v-if="userDetail">{{ userDetail.username || userDetail.nickname || '-'}}</span>
                                <span v-else>-</span>
                            </span>
                        </div>
                        <div class="detail-item">
                            <span class="key">手机号:</span>
                            <span class="value">
                                <span v-if="userDetail">{{userDetail.phone || '-'}}</span>
                                <span v-else>-</span>
                            </span>
                        </div>
                        <div class="detail-item">
                            <span class="key">车牌号:</span>
                            <span class="value">
                                <span>{{detail.license_plate_number || '-'}}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </a-col>
            <!-- 设备信息 -->
            <a-col :xs='24' :sm="24" :md="12" :xl="6" class="panel-block-content">
                <div class="panel-block">
                    <div class="block-title"><span>设备信息</span></div>
                    <div class="block-detail">
                        <div class="detail-item" :class="{ 'long-key': type === TYPE.CHARGE }" v-if="$auth('ADMIN')">
                            <span class="key">运营商:</span>
                            <span class="value">
                                <router-link target='_blank' :to="getRouterLink('operator')"
                                    v-if="$auth('operator.detail') && detail.operator_id && detail.operator_name">{{ detail.operator_name }}</router-link>
                                <span v-else>{{detail.operator_name || '-'}}</span>
                            </span>
                        </div>
                        <div class="detail-item" :class="{ 'long-key': type === TYPE.CHARGE }">
                            <span class="key">片区:</span>
                            <span class="value">
                                <router-link target='_blank' :to="getRouterLink('org')"
                                    v-if="$auth('org.detail') && detail.org_id && detail.org_name">{{detail.org_name}}</router-link>
                                <span v-else>{{detail.org_name || '-'}}</span>
                            </span>
                        </div>

                        <!-- 充电柜 信息 -->
                        <template v-if='type === TYPE.TANK'>
                            <div class="detail-item">
                                <span class="key">充电站名称:</span>
                                <span class="value">
                                    <router-link target='_blank' :to="getRouterLink('station')"
                                        v-if="detail.station_id && detail.station_name" >{{detail.station_name}}</router-link>
                                    <span v-else>{{detail.station_name || '-'}}</span>
                                </span>
                            </div>
                            <div class="detail-item">
                                <span class="key">网关:</span>
                                <span class="value">{{detail.plug_gateway_uid || '-'}}</span>
                            </div>
                            <div class="detail-item">
                                <span class="key">厂商UID:</span>
                                <span class="value">{{ detail.socket_uid  || '-' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="key">设备号:</span>
                                <span class="value">{{ detail.node_index }}号充电柜 - {{ detail.port_index + 1 }}仓</span>
                            </div>
                        </template>
                        <!-- 道闸 信息 -->
                        <template v-if='type === TYPE.GATE'>
                            <div class="detail-item">
                                <span class="key">厂商UID:</span>
                                <span class="value">
                                    <router-link target='_blank' :to="getRouterLink('gate')"
                                        v-if="detail.socket_uid">{{ detail.socket_uid }}</router-link>
                                    <span v-else>{{detail.socket_uid || '-'}}</span>
                                </span>
                            </div>
                            <div class="detail-item">
                                <span class="key">道闸号:</span>
                                <span class="value">{{ detail.node_index }}号道闸 - {{ PORT_NAME[detail.port_index + 1] }}杆</span>
                            </div>
                        </template>

                        <!-- 充电后占位 信息 -->
                        <template v-if='type === TYPE.CHARGE'>
                            <div class="detail-item long-key">
                                <span class="key">充电站:</span>
                                <span class="value">
                                    <router-link target='_blank' :to="getRouterLink('station')"
                                        v-if="detail.station_id && detail.station_name" >{{detail.station_name}}</router-link>
                                    <span v-else>{{detail.station_name || '-'}}</span>
                                </span>
                            </div>
                            <div class="detail-item long-key">
                                <span class="key">网关:</span>
                                <span class="value">{{detail.plug_gateway_uid || '-'}}</span>
                            </div>
                            <div class="detail-item long-key">
                                <span class="key">厂商UID:</span>
                                <span class="value">{{ detail.socket_uid  || '-' }}</span>
                            </div>
                            <div class="detail-item long-key">
                                <span class="key">设备号:</span>
                                <span class="value">{{ detail.node_index }}号设备 - {{ chargeDetail.port_name }}口</span>
                            </div>
                            <div class="detail-item long-key" >
                                <span class="key">关联充电订单:</span>
                                <span class="value">
                                    <router-link target='_blank' :to="getRouterLink('charge')" >{{chargeDetail.sn}}</router-link>
                                </span>
                            </div>
                             <div class="detail-item long-key" v-if="detail.pursue_order_id">
                                <span class="key">关联欠款订单:</span>
                                <span class="value">
                                    <router-link target='_blank' :to="getRouterLink('pursue')" >{{detail.pursue_order_sn}}</router-link>
                                </span>
                            </div>
                        </template>
                    </div>
                </div>
            </a-col>
            <!-- 订单信息 -->
            <a-col :xs='24' :sm="24" :md="12" :xl="6" class="panel-block-content">
                <div class="panel-block">
                    <div class="block-title"><span>订单信息</span></div>
                    <div class="block-detail">
                        <div class="detail-item">
                            <span class="key">订单号:</span>
                            <span class="value">{{ detail.sn }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="key">订单状态:</span>
                            <span class="value">{{ $Filter.occupyOrderStatusFilter(detail.status, occupyOrderStatusText) }}</span>
                        </div>
                        <template v-if="isFinish">
                            <template v-if="!flag.pay_by_card">
                                <div class="detail-item">
                                    <span class="key">结算状态:</span>
                                    <span class="value">{{ $Filter.clearingStatusFilter(detail.clearing_status) }}</span>
                                </div>
                                <div class="detail-item" v-if="flag.clearing_fail">
                                    <span class="key">失败原因:</span>
                                    <span class="value">{{ $Filter.valueFilter(detail.clearing_status, 'CLEARING.STATUS_MAP', 'tip') }}</span>
                                </div>
                            </template>
                            <div class="detail-item" v-if='type === TYPE.GATE'>
                                <span class="key">结束原因:</span>
                                <span class="value">{{ $Filter.orderFinishCodeFilter(detail.finish_code, 'OCCUPY') }}</span>
                            </div>
                        </template>

                        <div class="detail-item">
                            <span class="key">开始时间:</span>
                            <span class="value">{{ $Filter.timeFilter(detail.begin_time, type === TYPE.CHARGE ? 1 : 6) }}</span>
                        </div>
                        <div class="detail-item" v-if="isFinish">
                            <span class="key">结束时间:</span>
                            <span class="value">{{ $Filter.timeFilter(detail.end_time, type === TYPE.CHARGE ? 1 : 6) }}</span>
                        </div>

                        <div class="detail-item" v-if="isFinish">
                            <span class="key">占位时长:</span>
                            <span class="value">{{ detail.begin_time && detail.end_time ? $Filter.occupyTimeFilter(detail.begin_time, detail.end_time, type === TYPE.CHARGE ? true : false) || '0' : '-' }}</span>
                        </div>
                    </div>
                </div>
            </a-col>
            <!-- 支付信息 -->
            <a-col :xs='24' :sm="24" :md="12" :xl="6" class="panel-block-content">
                <div class="panel-block">
                    <div class="block-title"><span>支付信息</span></div>
                    <div class="block-detail">
                        <div class="detail-item">
                            <span class="key">下单时间:</span>
                            <span class="value">{{ $Filter.timeFilter(detail.pay_time || detail.create_time, 6) }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="key">付款方式:</span>
                            <span class="value">
                                <i class="icon" :class="$Filter.occupyOrderPayMethodFormat(detail.pay_method, 'icon')" />
                                {{ $Filter.occupyOrderPayMethodFormat(detail.pay_method) }}
                            </span>
                        </div>
                        <div class="detail-item" v-if="$Filter.isPayByCard(detail.pay_method,'occupy')">
                            <span class="key">付款卡号:</span>
                            <span class="value">
                                <router-link target='_blank' v-if="detail.card_uid && $auth('card.list')" :to="getRouterLink('card')" >{{detail.card_uid}}</router-link>
                                <span v-else>{{detail.card_uid || '-'}}</span>
                            </span>
                        </div>
                        <div class="detail-item">
                            <span class="key">支付金额:</span>
                            <span class="value">
                                <span class="bold">￥{{ $Filter.moneyFilter(detail.price) }}</span>
                            </span>
                        </div>
                        <template v-if='type === TYPE.GATE && isFinish'>
                            <div class="detail-item consumed">
                                <span class="key">实际花费:</span>
                                <span class="value">
                                    <template v-if="$auth('ADMIN')">￥{{ $Filter.moneyFilter(detail.money_consumed) }}</template>
                                    <template v-else>￥{{ detail.price ? $Filter.moneyFilter(detail.money_consumed) : 0 }}</template>
                                </span>
                            </div>
                            <div class="detail-item">
                                <span class="key">实际收费:</span>
                                <span class="value">
                                    <template>￥{{ $Filter.moneyFilter(detail.charge) }}</template>
                                </span>
                            </div>
                            <div class="detail-item" v-if="detail.price > detail.money_consumed">
                                <span class="key">退还金额:</span>
                                <span class="value">
                                    ￥{{ $Filter.moneyFilter(detail.price - detail.money_consumed) }}
                                </span>
                            </div>
                            <div class="detail-item long-key" v-if="detail.refund_money">
                                <span class="key">结算后退款金额:</span>
                                <span class="value">
                                    ￥{{ $Filter.moneyFilter(detail.refund_money) }}
                                </span>
                            </div>
                        </template>
                    </div>
                </div>
            </a-col>
        </a-row>
    </div>
    <div class="panel-container" v-if="type === TYPE.GATE && (chargeDetail.id || pursueDetail.id)"> <!-- 相关订单 -->
        <div class="panel-title">
            <div class="title-area">相关订单</div>
            <div class="btn-area"></div>
        </div>
        <a-row class="panel-content">
            <!-- 充电订单 -->
            <a-col :xs='24' :sm="24" :md="12" class="panel-block-content" v-if="chargeDetail.id">
                <div class="panel-block">
                    <div class="block-title"><span>充电订单</span></div>
                    <div class="block-detail">
                        <div class="detail-item">
                            <span class="key">订单号:</span>
                            <span class="value">
                                <router-link target='_blank' :to="getRouterLink('charge')" >{{chargeDetail.sn}}</router-link>
                            </span>
                        </div>
                        <div class="detail-item">
                            <span class="key">订单状态:</span>
                            <span class="value">{{ $Filter.orderStatusFilter(chargeDetail.status) }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="key">创建时间:</span>
                            <span class="value">{{ $Filter.timeFilter(chargeDetail.create_time, 6) }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="key">结束时间:</span>
                            <span class="value">{{ $Filter.timeFilter(chargeDetail.finish_time, 6) }}</span>
                        </div>
                        <div class="detail-item long-key">
                            <span class="key">充电前占位时长:</span>
                            <span class="value">{{ $Filter.occupyTimeFilter(detail.begin_time, chargeDetail.create_time) }}</span>
                        </div>
                        <div class="detail-item long-key">
                            <span class="key">充电后占位时长:</span>
                            <span class="value">{{ $Filter.occupyTimeFilter(chargeDetail.finish_time, detail.end_time) }}</span>
                        </div>
                    </div>
                </div>
            </a-col>
            <!-- 追款订单 -->
            <a-col :xs='24' :sm="24" :md="12" class="panel-block-content" v-if="pursueDetail.id">
                <div class="panel-block">
                    <div class="block-title"><span>追款订单</span></div>
                    <div class="block-detail">
                        <div class="detail-item">
                            <span class="key">订单号:</span>
                            <span class="value">
                                <router-link target='_blank' :to="getRouterLink('pursue')" >{{pursueDetail.sn}}</router-link>
                            </span>
                        </div>
                        <div class="detail-item">
                            <span class="key">订单状态:</span>
                            <span class="value">{{ $Filter.pursueOrderStatusFilter(pursueDetail.status) }}</span>
                        </div>
                        <div class="detail-item red">
                            <span class="key">欠款金额:</span>
                            <span class="value">￥{{ $Filter.moneyFilter(pursueDetail.price) }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="key">创建时间:</span>
                            <span class="value">{{ $Filter.timeFilter(pursueDetail.create_time, 6) }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="key">补款时间:</span>
                            <span class="value">{{ $Filter.timeFilter(pursueDetail.pay_time, 6) }}</span>
                        </div>
                    </div>
                </div>
            </a-col>
        </a-row>
    </div>

    <!-- 订单明细 -->
    <OccupyDetails @card="handleEmitCard" :detail="detail" v-if="type === TYPE.CHARGE && flag.is_pay" />

    <OrderClearingLog  ref="OrderClearingLog" :id='orderId' type='occupy' />
    <MoneyChangeHistory ref="MoneyChangeHistory" v-if="flag_order" :id='orderId' type='occupy' :deviceType="type" :getPursue="(detail.pursue_order_id && type === TYPE.CHARGE) ? true : false" :pursueOrderId='detail.pursue_order_id' />

    <template class="modal-container">
        <a-modal v-model="refundVisible" title="订单退款"
			class="modal-new" :width="470" :after-close='handleOrderRefundClose'>
			<div class="modal-content">
                <a-alert type="warning" v-if="flag.can_pursue_refund">
					<span class="message" slot="message">
						<i class="icon i-warning-new" />
						<div class="text">
							<div class="text-item">部分金额需到欠款订单中退款</div>
							<div class="line"></div>
							<div class="text-item">订单编号：<span class="orange underline" @click="routerChange('pursue')">{{ detail.pursue_order_sn }}</span></div>
						</div>
					</span>
				</a-alert>

				<div class="input-container">
					<a-input-number placeholder="请输入返还金额" v-model="refundValue" :precision='2' :min="0"/>
                    <div class="addon-after">元</div>
				</div>
                <div class="tip">该订单占位最多可退{{ $Filter.moneyFilter(refundMaxPrice) }}元 <span class="btn" @click="refundValue = $Filter.moneyFilter(refundMaxPrice)">填入全部金额</span></div>
			</div>
			<template slot="footer">
                <a-button @click="refundVisible = false">取消</a-button>
				<a-button type="primary" @click="handleOrderRefundConfirm" :disabled="!refundBtnAble || !detail.charge">退款</a-button>
			</template>
		</a-modal>

        <!-- 退款成功  查看欠款订单弹窗 -->
        <MyConfirm :visible="refundResultVisible" icon="i-success-new" title="退款成功" :closable="false" infoAlign="left" @close="refundResultVisible = false">
            <template slot="tip">
                <div>部分金额请前往欠款订单中退款</div>
            </template>
            <template slot="btn-area">
                <a-button type="primary" @click="routerChange('pursue')">
					查看欠款订单
				</a-button>
				<a-button class="cancel" @click="refundResultVisible = false">
					关闭
				</a-button>
			</template>
        </MyConfirm>
    </template>
</div>
</template>

<script>
import Core from '../../core';
import PayDetails from '@/core/occupy-pay-details';

const PAY_METHOD = Core.Const.OCCUPY.PAY_METHOD;
const PAY_METHOD_MARK = Core.Const.OCCUPY.PAY_METHOD_MARK;
const STATUS = Core.Const.OCCUPY.STATUS;
const TYPE = Core.Const.OCCUPY.TYPE;

const CLEARING_STATUS = Core.Const.CLEARING.STATUS;
const CLEARING_STATUS_MARK = Core.Const.CLEARING.STATUS_MARK;

const REFUND_STATUS = Core.Const.ORDER.REFUND_STATUS;
const REFUND_STATUS_MARK = Core.Const.ORDER.REFUND_STATUS_MARK;

const PURSUE_STATUS = Core.Const.PURSUE.STATUS;

const CUSTOM_ORDER_TYPE = PayDetails.CUSTOM_ORDER_TYPE;

export default {
    name: 'OccupyOrderDetail',
    components: {
        MoneyChangeHistory: () => import('@/components/panel/MoneyChangeHistory.vue'),
        OrderClearingLog: () => import('@/components/panel/OrderClearingLog.vue'),
        OccupyOrderStatus: () => import('./components/OccupyOrderStatus.vue'),
        OccupyDetails: () => import('./components/OccupyDetails.vue'),
    },
    props: {},
    data() {
        return {
            PURSUE_STATUS,
            PORT_NAME: Core.Const.DEVICE.PORT_NAME.NORMAL,
            TYPE,
            type: '',
            loading: false,

            orderId: '',
            detail: {},     // 占用单详情
            userDetail: {}, // 用户详情

            gateDetail: {}, // 设备信息
            chargeDetail: {}, // 充电订单详情
            pursueDetail: {},  // 欠款订单详情

            refundVisible: false,
            refundTip: false,
			refundValue: '',
			refundBtnAble: true,
            refundMaxPrice: 0,

            refundResultVisible: false,

			clearing_config_id: '',

            flag_order: false, // 是否已经获取订单详情
        };
    },
    watch: {
        $route: {
            deep: true,
            immediate: true,
            handler(newRoute) {
                this.type = newRoute.meta.type
            }
        },
        refundVisible(newVal, oldVal) {
            if (newVal) {
                this.getRefundMaxPrice();
            }
        },
    },
    computed: {
        canRefund() { // 结算后退款
            switch (this.detail.pay_method) {
                case PAY_METHOD.WECHART:
                case PAY_METHOD.ALIPAY:
                    if (this.detail.clearing_status === CLEARING_STATUS.SUCCESS) {
                        switch (this.detail.refund_status) {
                            case REFUND_STATUS.DOING:
                            case REFUND_STATUS.ACCOUNT_SUCCESS:
                            case REFUND_STATUS.ALL_SUCCESS:
                                return false
                            default:
                                if (this.type === TYPE.TANK && this.detail.status === STATUS.SUCCESS) {
                                    return true
                                } else if (this.type !== TYPE.TANK && this.isFinish) {
                                    return true
                                }
                        }
                    }
                    return false
                case PAY_METHOD.RECHARGE:
                case PAY_METHOD.CAR_CARD:
                    switch (this.detail.refund_status) {
                        case REFUND_STATUS.DOING:
                        case REFUND_STATUS.ACCOUNT_SUCCESS:
                        case REFUND_STATUS.ALL_SUCCESS:
                            return false
                        default:
                            if (this.type === TYPE.TANK && this.detail.status === STATUS.SUCCESS) {
                                return true
                            } else if (this.type !== TYPE.TANK && this.isFinish) {
                                return true
                            }
                    }
            }
            return false
		},
        needClearing() { // 需要结算且尚未结算
            if (this.detail.clearing_status === CLEARING_STATUS.BEFORE) {
                switch (this.detail.pay_method) {
                    case PAY_METHOD.WECHART:
                    case PAY_METHOD.ALIPAY:
                        if (this.type === TYPE.TANK && this.detail.status === STATUS.SUCCESS) {
                            return true;
                        }
                        else if (this.type === TYPE.GATE && this.detail.status === STATUS.FINISH) {
                            return true;
                        } else if (this.type === TYPE.CHARGE && this.detail.status === STATUS.FINISH) {
                            // 充电后占位订单
                            return true;
                        } else {
                            return false;
                        }
                    default: return false;
                }
            }
            return false;
        },
        isFinish() {
            switch (this.detail.status) {
                case STATUS.SUCCESS:
                    if (this.type === TYPE.TANK) {
                        return true
                    } else {
                        return false
                    }
                case STATUS.FINISH:
                case STATUS.WAITING_REFUND:
                case STATUS.WAITING_REFUND_NEW:
                case STATUS.COMPLETE_REFUND:
                    return true
                default:
                    return false
            }
        },
        OccupyOrderDetailShow() {
            let show = false;
            switch (this.type) {
                case TYPE.CHARGE:
                    show = Core.Util.auth("car-occupy.view")
                    break;
                default:
                    show = Core.Util.auth("order.detail")
                    break;
            }
            return show;
        },
        occupyOrderStatusText() {
            let text = 'text';

            switch (this.type) {
                case TYPE.GATE:
                    text = 'text_gate';
                    break;
            }

            return text;
        },
        flagCard() {
            const MARK = Core.Const.OCCUPY.PAY_METHOD_MARK;
            return {
                card: MARK.CARD.includes(this.detail.pay_method),
                reality: MARK.REALITY_CARD.includes(this.detail.pay_method),
                virtual: MARK.VIRTUAL_CARD.includes(this.detail.pay_method),

                pursue_card: MARK.CARD.includes(this.pursueDetail.pay_method),
                pursue_reality: MARK.REALITY_CARD.includes(this.pursueDetail.pay_method),
                pursue_virtual: MARK.VIRTUAL_CARD.includes(this.pursueDetail.pay_method),
            }
        },
        flag() {
            let flag = {
                is_pay: false, // 是否支付

                can_pursue_refund: false, // 欠款退款

                can_refund: false, // 可结算后退款  	【第二次退款】
                pay_by_card: false, // 是否卡片支付
                clearing_fail: false, // 是否结算失败
            };

            let pursueDetail = this.pursueDetail;

            if (this.detail.status !== STATUS.UNPAY) {
				flag.is_pay = true;
			}

            // 欠款订单已支付且未退款
            if (!Core.Util.isEmptyObj(pursueDetail) && pursueDetail.status === PURSUE_STATUS.PAYED && pursueDetail.price === pursueDetail.charge) {
                flag.can_pursue_refund = true;
            }

            // 可结算后退款  	【第二次退款】
            if (REFUND_STATUS_MARK.CAN_NOT_REFUND.includes(this.detail.refund_status)) {
                flag.can_refund = false;
            } else {
                if ((PAY_METHOD_MARK.NEED_CLEARING.includes(this.detail.pay_method) && this.detail.clearing_status === CLEARING_STATUS.SUCCESS) // 需要结算 且 订单已经结算
                || (!PAY_METHOD_MARK.NEED_CLEARING.includes(this.detail.pay_method) && this.isFinish) 		    // 或 不需要结算 且 订单已经结束
                ) {
                    flag.can_refund = this.detail.charge > 0 ? true : false
                } else {
                    flag.can_refund = false
                }
            }

            flag.pay_by_card = PAY_METHOD_MARK.NORMAL_CARD.includes(this.detail.pay_method)
            flag.clearing_fail = CLEARING_STATUS_MARK.FAIL.includes(this.detail.clearing_status)

            return flag;
        },
    },
    created() {
        this.orderId = this.$route.query.id;
        this.getOrderDetail();
    },
    filters: {},
    methods: {
        getRouterLink(type, id) {
			switch (type) {
                case 'card':
                    return { path: '/card/virtual-card-detail', query: { uid: this.detail.card_uid, }, }
                case 'operator':
                    return { path: '/operator/operator-detail', query: { operator_id: this.detail.operator_id }, }
                case 'org':
                    return { path: '/org/org-detail', query: { org_id: this.detail.org_id }, }
                case 'station':
                    return { path: '/station/station-detail', query: { station_id: this.detail.station_id }, }
                case 'charge':
                    return { path: '/charing-order/order-detail', query: { id: this.chargeDetail.id }, }
                case 'pursue':
                    return { path: '/occupy-order/pursue-order-detail', query: { id: this.pursueDetail.id }, }
                case 'gate':
                    return { path: '/device/gate-detail', query: { id: this.gateDetail.id }, }
			}
		},
        routerChange(index, params) {
            let routeUrl;
            switch (index) {
                case 'card': // 卡片详情
                    let path = '';
                    if (this.flagCard.reality) {
                        path = '/card/reality-card-detail';
                    }
                    else if (this.flagCard.virtual) {
                        path = '/card/virtual-card-detail';
                    }
                    routeUrl = this.$router.resolve({
                        path,
                        query: {
                            uid: this.detail.card_uid,
                        },
                    });
                    break;
                case 'pursue':
                    routeUrl = this.$router.resolve({
                        path: '/occupy-order/pursue-order-detail',
                        query: {
                            id: this.pursueDetail.id,
                        },
                    });
                    break;
                case 'custom':
                    routeUrl = this.$router.resolve({
                        path: params.path,
                        query: params.query,
                    });
                    break;
            }
            window.open(routeUrl.href, '_blank');
        },

        // 查看卡片
        handleEmitCard(item) {
            let params = {};
            let query = {};
            switch (item.order_type) {
				case CUSTOM_ORDER_TYPE.occupy:  // 占位
                    if (this.flagCard.reality) {
                        params.path = '/card/reality-card-detail';
                    }
                    else if (this.flagCard.virtual) {
                        params.path = '/card/virtual-card-detail';
                    }

                    query.uid = item.card_uid;
					break;
				case CUSTOM_ORDER_TYPE.pursue:  // 欠款
                    if (this.flagCard.pursue_reality) {
                        params.path = '/card/reality-card-detail';
                    }
                    else if (this.flagCard.pursue_virtual) {
                        params.path = '/card/virtual-card-detail';
                    }

                    query.uid = item.card_uid;
					break;
			}

            if (Core.Util.isEmptyObj(params)) return;

            params.query = query;

            this.routerChange('custom', params);
        },

        // 获取订单详情
        getOrderDetail(flag_get = false) {
            this.loading = true
            Core.Api.OccupyOrder.detail(this.orderId).then(res => {
                console.log("getOrderDetail res", res);
                this.detail = res;
                this.loading = false
                this.flag_order = true;
                this.getUserInfo();
                if (this.type === TYPE.GATE || this.type === TYPE.CHARGE) {
                    this.getDeviceDetail()
                    this.getChargeOrderDetail()
                    this.getPursueOrderDetail()
                }

                if (flag_get) {
                    // 更新组件数据
                    this.$nextTick(() => {
                        // 结算明细
                        if (this.$refs['OrderClearingLog']) {
                            this.$refs['OrderClearingLog'].getTableData();
                        }
                        // 金额变动记录
                        if (this.$refs['MoneyChangeHistory']) {
                            this.$refs['MoneyChangeHistory'].getTableData();
                        }
                    })
                }
            }).catch(err => {
                console.log('getOrderDetail err:', err)
                this.loading = false
            })
        },
        // 获取用户信息
        getUserInfo() {
            Core.Api.User.detail(this.detail.user_id).then(res => {
                console.log("getUserInfo res", res);
                this.userDetail = res.user;
            })
        },
        // 获取充电订单信息
        getChargeOrderDetail() {
            if (!this.detail.order_id) { return }
            this.loading = true
            Core.Api.Order.detail(this.detail.order_id).then(res => {
                console.log("getChargeOrderDetail res", res)
                this.chargeDetail = res || {}
                this.loading = false;
            }).catch(err => {
                console.log("getChargeOrderDetail err", err)
                this.loading = false;
            })
        },
        // 获取欠款订单信息
        getPursueOrderDetail() {
            if (!this.detail.pursue_order_id) { return }
            this.loading = true
            Core.Api.PursueOrder.detail(this.detail.pursue_order_id).then(res => {
                console.log("getPursueOrderDetail res", res)
                this.pursueDetail = res || {}
                this.loading = false;
            }).catch(err => {
                console.log("getPursueOrderDetail err", err)
                this.loading = false;
            })
        },
        getDeviceDetail() {
            Core.Api.Gate.detailBySuid(this.detail.socket_uid).then(res => {
                console.log('getDeviceDetail res:', res)
                this.gateDetail = res || {}
            })
        },

        // 获取分账模版Id
        async getClearingConfigId() {
            if (this.detail.station_id) {
                let stationConfig = await Core.Api.OperatorConfig.detailByStationId(this.detail.station_id)
                this.clearing_config_id = stationConfig.clearing_config_id
            } else {
                let orgConfig = await Core.Api.OperatorConfig.detailByOrgId(this.detail.org_id)
                this.clearing_config_id = orgConfig.clearing_config_id
            }
            console.log('this.clearing_config_id:', this.clearing_config_id)
		},

        // 手动结算
        hanldeManualClearing() {
            this.$confirm({
                title: '确定要立即结算该笔订单吗？',
                okText: '确定',
                cancelText: '取消',
                onOk: () => {
                    this.loading = true
                    Core.Api.OccupyOrder.manualClearing(
                        this.orderId,
						Core.Const.ORDER.TYPE.OCCUPY,
                    ).then(() => {
                        this.$message.success('操作成功');
                        this.getOrderDetail(true);
                    }).catch(err => {
                        console.log("hanldeManualClearing err", err)
                        this.loading = false;
                    })
                },
            });
        },

        // 订单退款 - 结算后退款

		// 检查当前订单支付所用的卡片是否属于“已废弃”状态
		async checkDisableCard() {
			let apiName = 'Card'
			switch (this.detail.pay_method) {
				case PAY_METHOD.RECHARGE:
				case PAY_METHOD.CAR_CARD:
					apiName = 'VirtualCard'
					break;
				default:
					return false
			}
			try {
				let res = await Core.Api[apiName].detail(this.detail.card_uid)
				console.log('checkDisableCard res:', res)
				let d = res ? (res.virtual_card || res.card_detail || res || {}) : {}

				if (d.status === Core.Const.CARD.STATUS.DISCARD && !d.new_card_uid) {
					this.$warning({
						title: '无法退款',
						content: `卡片[UID: ${this.detail.card_uid}]已废弃，已更换成新卡，请手动往新卡中充值待退款的金额`,
						okText: '确定',
					});
					return true
				}
			} catch (err) {
				this.$warning({
					title: '无法退款',
					content: `卡片[UID: ${this.detail.card_uid}]信息获取失败, 请确认卡片是否在系统中存在`,
					okText: '确定',
				});
				return true
			}
			return false
		},
        async handleOrderRefundShow() {
			if (await this.checkDisableCard()) { return }
			this.getClearingConfigId()
            this.refundVisible = true
		},
        handleOrderRefundClose() {
			this.refundVisible = false;
			this.refundValue = '';
		},
        // 计算最大退款金额
        getRefundMaxPrice() {
            let price = 0;
            price = this.detail.charge || 0;
            this.refundMaxPrice = price;
        },
        handleOrderRefundConfirm() {
            if (!this.refundValue) {
                return this.$message.warning('请输入退款金额,且小数位不要超过两位')
            }
            if (this.refundValue > (this.detail.charge/100)) {
                return this.$message.warning('退款金额不能大于实际花费')
            }
            this.refundBtnAble = false
            let funName = this.type === TYPE.GATE ? 'refundGateAfterClearing' : 'refundAfterClearing'
            Core.Api.OccupyOrder[funName](
                this.detail.sn,
                this.clearing_config_id,
                parseInt(this.refundValue * 100),
            ).then(res => {
                this.$message.success('退款成功')
                this.handleOrderRefundClose()
                this.getOrderDetail(true)

                if (this.flag.can_pursue_refund) {
                    // 出现退款成功弹窗
                    this.refundResultVisible = true;
                }
            }).catch(err => {
                this.refundBtnAble = true
                console.log("handleOrderRefundConfirm err", err)
            })
		},
    }
};
</script>

<style lang="scss" scoped>
#OccupyOrderDetail {
    .panel-container {
        .title {
            font-size: $fz_title;
            color: $tc_import;
            display: flex;
            align-items: center;
        }
    }
    .table-container {
        width: 100%;
    }
    .title-area {
        .status {
            margin-left: 30px;
            font-size: 14px;
        }
    }
}
</style>